/**
 * Application settings and features - per APP_ID per deployment
 * Production object is the DEFAULT
 * If staging exists it will overwrite defaults
 *
 * READ THE DOCS BEFORE ADDING A FEATURE
 * DON'T FORGET TO ALSO ADD NEW FEATURES TO THE DOCS
 *
 */

const config = {
  wesave: {
    params: {
      appId: 'wesave',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        aggregationType: 'webview',
        userAccountsFree: true,
        realEstate: true,
        realEstateEstimator: true,
        aAssistanceUrl: false,
        aClientView: true,
        aFaqUrl: false,
        aMissions: true,
        aPreferUserId: false,
        aInviteClients: true,
        aInteractions: true,
        aManualInternalManagement: true,
        aShowClientRisk: true,
        aShowReco: true,
        cAssistanceUrl: 'http://help.wesave.fr/wesave-conseil',
        cDebtRatio: true,
        enableConseil: true,
        allowUserRegistration: true,
        enableMaintenancePage: false
      },
      staging: {
        realEstate: true,
        realEstateEstimator: true
      }
    }
  },

  liins: {
    params: {
      appId: 'liins',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        aggregationType: 'webview',
        userAccountsFree: true,
        realEstate: true,
        realEstateEstimator: false,
        aAssistanceUrl: 'https://wesave.typeform.com/to/LtscVM',
        aClientView: true,
        aFaqUrl: 'https://intercom.help/liins-conseil',
        aMissions: false,
        aPreferUserId: false,
        aInviteClients: true,
        aInteractions: true,
        aManualInternalManagement: true,
        aShowClientRisk: true,
        aShowReco: true,
        cAssistanceUrl: false,
        cDebtRatio: false,
        enableConseil: true,
        allowUserRegistration: true
      },
      staging: {
        realEstate: true
      }
    }
  },

  primonial: {
    params: {
      appId: 'primonial',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        aggregationType: 'webview',
        userAccountsFree: true,
        realEstate: false,
        realEstateEstimator: false,
        aAssistanceUrl: false,
        aClientView: false,
        aFaqUrl: false,
        aMissions: false,
        aPreferUserId: true,
        aInviteClients: false,
        aInteractions: false,
        aManualInternalManagement: false,
        aShowClientRisk: false,
        aShowReco: false,
        cAssistanceUrl: false,
        cDebtRatio: false,
        enableConseil: true,
        allowUserRegistration: false
      }
    }
  },

  poctp: {
    params: {
      appId: 'poctp',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        aggregationType: 'webview',
        userAccountsFree: true,
        realEstate: true,
        realEstateEstimator: true,
        aAssistanceUrl: false,
        aClientView: true,
        aFaqUrl: false,
        aMissions: false,
        aPreferUserId: false,
        aInviteClients: false,
        aInteractions: true,
        aManualInternalManagement: true,
        aShowClientRisk: true,
        aShowReco: true,
        cAssistanceUrl: false,
        cDebtRatio: false,
        enableConseil: true,
        allowUserRegistration: false
      }
    }
  }
}

export function featureFlag(feature) {
  const env = process.env.NODE_ENV
  const appId = process.env.APP_ID
  let cfg = config[appId].features

  if ((env === 'staging' || env === 'development') && cfg.staging) {
    cfg = Object.assign({}, cfg.production, cfg.staging)
  } else {
    cfg = cfg.production
  }

  if (!cfg.hasOwnProperty(feature)) {
    throw new Error(`Feature name does not exist - ${feature}`)
  } else {
    return Boolean(cfg[feature])
  }
}

export default config
